import {
  ChangeDetectorRef,
  Component,
  NgZone,
  OnDestroy,
  OnInit,
} from '@angular/core';
import { NbDialogRef, NbDialogService } from '@nebular/theme';
import { AbsensiService } from '../../../services/absensi.service';
import { UtilService } from '../../../services/util.service';
import { Subscription } from 'rxjs';
import { CustomDialogComponent } from '../custom-dialog/custom-dialog.component';
import { Router } from '@angular/router';
import { PromptDialogComponent } from '../prompt-dialog/prompt-dialog.component';

@Component({
  selector: 'ngx-menu-select',
  templateUrl: './menu-select.component.html',
  styleUrls: ['./menu-select.component.scss'],
})
export class MenuSelectComponent implements OnInit, OnDestroy {
  isLuarKantorAllowed: boolean = false;
  isWfhAllowed: boolean = false;
  isLoading: boolean = false;

  private subscriptions: Subscription[] = [];

  constructor(
    protected dialogRef: NbDialogRef<MenuSelectComponent>,
    private absensiService: AbsensiService,
    private utilService: UtilService,
    private dialogService: NbDialogService,
    private zone: NgZone,
    private cdr: ChangeDetectorRef,
    private router: Router,
  ) {}

  ngOnInit(): void {
    this.absensiService.checkAllowAbsenLuar();
    this.absensiService.checkAllowWfh();

    this.subscriptions.push(
      this.absensiService.isAllowedLuarKantorSubject.subscribe((res) => {
        this.zone.run(() => {
          if (res && res.success !== undefined) {
            this.isLuarKantorAllowed = res.success;
          } else if (typeof res === 'boolean') {
            this.isLuarKantorAllowed = res;
          }
        });
      }),
    );

    this.subscriptions.push(
      this.absensiService.isAllowedWfhSubject.subscribe((res) => {
        this.zone.run(() => {
          if (res && res.success !== undefined) {
            this.isWfhAllowed = res.success;
          } else if (typeof res === 'boolean') {
            this.isWfhAllowed = res;
          }
        });
      }),
    );
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach((sub) => sub.unsubscribe());
  }

  private getModeLabel(mobileType: number): string {
    switch (mobileType) {
      case 2:
        return 'Luar Kantor';
      case 3:
        return 'WFH';
      default:
        return 'Umum';
    }
  }

  private normalizeMode(mode: number): number {
    return mode === null || mode === undefined || mode === 1 ? 1 : mode;
  }

  selectMode(mode: number) {
    if (mode === 2 && !this.isLuarKantorAllowed) return;
    if (mode === 3 && !this.isWfhAllowed) return;
    if (this.isLoading) return;

    this.isLoading = true;
    this.cdr.detectChanges();

    if (mode === 3) {
      this.utilService.apiGet('absensi/get-lokasi', {}).subscribe({
        next: (locRes) => {
          const allLocations = locRes.data || [];
          const wfhLocations = allLocations.filter((loc) =>
            (loc.lokasi || '').toLowerCase().includes('wfh'),
          );

          if (wfhLocations.length === 0) {
            this.isLoading = false;
            this.cdr.detectChanges();
            this.dialogRef.close();
            const dialog = this.dialogService.open(PromptDialogComponent, {
              context: {
                header: 'Lokasi Rumah WFH Tidak Ditemukan',
                body: 'Anda belum memiliki lokasi rumah yang aktif, lakukan pengajuan lokasi',
                status: 'warning',
                btn_action_name: 'Pengajuan Lokasi WFH',
                show_cancel_button: true,
              },
            });
            dialog.onClose.subscribe((res) => {
              if (res.event === true) {
                this.router.navigateByUrl('/app/absensi/wfh/pengajuan-lokasi');
              }
            });
          } else {
            this.proceedCekModeAbsen(mode);
          }
        },
        error: () => {
          this.isLoading = false;
          this.cdr.detectChanges();
        },
      });
    } else {
      this.proceedCekModeAbsen(mode);
    }
  }

  proceedCekModeAbsen(mode: number) {
    this.utilService
      .apiGet('absensi/cek-mode-absen', { selected_mode: mode })
      .subscribe({
        next: (res: any) => {
          this.isLoading = false;
          this.cdr.detectChanges();

          const canProceed = res.data?.can_proceed ?? res.can_proceed;

          if (canProceed) {
            this.dialogRef.close(mode);
          } else {
            this.dialogRef.close();
            this.dialogService.open(CustomDialogComponent, {
              context: {
                header: 'Mode Absen Tidak Sesuai',
                body: res.msg || 'Tidak dapat mengganti mode presensi.',
                status: 'warning',
              },
            });
          }
        },
        error: (err) => {
          this.isLoading = false;
          this.cdr.detectChanges();
          this.dialogRef.close(mode);
        },
      });
  }

  goBack() {
    this.dialogRef.close();
  }
}
